<template>
	<div class="page-container">
        <e-nav :type="4"></e-nav>
        <div class="list-container">
            <!-- <label class="title">CMA2019规则和奖项</label> -->
             <div class="list-content">
                <div class="list-cell">
                    <div class="list-body">
                        <p>CMA总则<br>&nbsp;</p>
                        <a href="http://static01.cmicawards.org.cn/202111/CMA%E6%80%BB%E5%88%99.pdf" target="_blank">文档预览</a>
                    </div>
                </div>
                <div class="list-cell">
                    <div class="list-body">
                        <p>CMA评选细则（2020&2021）</p>
                        <a href="http://static01.cmicawards.org.cn/202111/CMA%E8%AF%84%E9%80%89%E7%BB%86%E5%88%99%EF%BC%882020&2021%EF%BC%89.pdf" target="_blank">文档预览</a>
                    </div>
                </div>
                <div class="list-cell">
                    <div class="list-body">
                        <p>CMA奖项设置及说明（2020&2021）</p>
                        <a href="http://static01.cmicawards.org.cn/202111/CMA%E5%A5%96%E9%A1%B9%E8%AE%BE%E7%BD%AE%E5%8F%8A%E8%AF%B4%E6%98%8E%EF%BC%882020&2021%EF%BC%89.pdf" target="_blank">文档预览</a>
                    </div>
                </div>
            </div>
        </div>
		<!-- <div v-for="(list, index) in listData" :key="index" class="list-container">
            <label class="title">{{list.title}}</label>
            <div class="list-content">
                <div v-for="(item, index) in list.data" :key="index" class="list-cell">
                    <div class="list-body">
                        <img src="./../assets/images/cup_0.png" class="img"/>
                        <span>{{item.name}}</span>
                    </div>
                </div>
            </div>
        </div> -->
	</div>
</template>

<script>
//import listData from '@/mock/cma2019'
import eNav from '@/components/Nav'
export default {
	name: 'cma_index',
    components: {
        eNav
    },
	data () { 
		return {
            listData: []
		}
	},
	mounted: function() {
        //this.listData = listData;
    },
	methods:{}
}
</script>
<style lang="scss" scoped>
    .page-container{
        padding: 0;
    }
	.list-container {
        overflow: hidden;
        margin-bottom: 200px;
		.title {
            display: block;
            margin-top: 40px;
            line-height: 24px;
			font-size: 24px;
            color: #181413;
		}

        .list-content{
            margin-top: 20px;
            overflow: hidden;

            .list-cell {
                float: left;
                width: 386px;
                padding: 140px 0;
                margin-right: 20px;
                text-align: center;
                background: #FBFCFE;
                &:last-child{
                    margin-right: 0;
                }
                .list-body {
                    
                    p{
                        font-size: 30px;
                        color: #000000;
                    }
                    a{
                        display: inline-block;
                        font-size: 16px;
                        color: #FFFFFF;
                        background: #181413;
                        border-radius: 25px;
                        height: 50px;
                        width: 152px;
                        line-height: 50px;
                        text-align: center;
                        margin-top: 20px;
                    }
                }
            }
        }
	}
</style>

